'use client'

import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handleCMS } from "@/(front-desk)/store"
import { reportError } from "@/(front-desk)/utils/functions"
import { LoadingIcon } from "@/(front-desk)/utils/patterns"
import { useTranslation } from "@/(front-desk)/hooks/useTranslation"
import locales from "@/(front-desk)/(pages)/information/information.i18n"
import ActivityDetail from "@/(front-desk)/(pages)/information/components/ActivityDetail"
import LanguageBtn from "@/(front-desk)/components/LanguageBtn"
import Transition from "@/(front-desk)/components/Transition"
import Marquee from "@/(front-desk)/components/Marquee"
import classNames from "classnames"
import dayjs from "dayjs"
import axios from "axios"
import slogan from "@/(front-desk)/assets/images/information/timetable/slogan.png"
import comingSoon from "@/(front-desk)/assets/images/background/coming-soon.png"

export default function informationTimeTable() {

    const [ active, setActive ] = useState(null)
    const [ detail, setDetail ] = useState(null)
    const dispatch = useDispatch()
    const { language, translations } = useTranslation(locales)
    const infoEvents = useSelector((state) => state.CMS).infoEvents[language]
    const downloadTimetable = useSelector((state) => state.CMS).infoTimetable[language]?.download_timetable
    const content = translations.timetable
    const categories = [...new Map(infoEvents?.map(e => [JSON.stringify(e.category), e.category])).values()]
    const [ timetable, setTimetable ] = useState(null)
    const global = useSelector((state) => state.global)

    useEffect(() => {
        if (language && !infoEvents) {
            axios.get(`/api/v1/cms/${language}/events?time_table=true&year=${global.currentCompeteYear}`)
            .then((res) => {
                // console.log(res.config?.url, res.data.body)
                dispatch(handleCMS.actions.setInfoEvents({
                    language: language,
                    data: res.data.body
                }))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
            })
        }
        if (language && !downloadTimetable) {
            axios.get(`/api/v1/cms/${language}/events/time-table/info`)
            .then((res) => {
                // console.log(res.config?.url, res.data.body)
                dispatch(handleCMS.actions.setInfoTimetable({
                    language: language,
                    data: res.data.body
                }))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
            })
        }

        if (infoEvents) {
            const groupEvents = (infoEvents) => {
                const grouped = infoEvents.reduce((acc, e) => {
                    const date = dayjs(e.start_time).format('YYYY-M-D')
                    acc[date] ??= {}
                    acc[date][e.category.shortcut] ??= { ...e.category, events: [] }
                    acc[date][e.category.shortcut].events.push(e)
                    return acc
                }, {})

                return Object.entries(grouped)
                    .sort(([a], [b]) => dayjs(a).valueOf() - dayjs(b).valueOf())
                    .map(([date, catMap]) => ({
                        date,
                        categories: categories.map(cat => catMap[cat.shortcut] ?? { ...cat, events: [] })
                            .sort((a, b) => a.order - b.order)
                    }))
            }

            setTimetable(groupEvents(infoEvents))
            setActive(groupEvents(infoEvents)?.[0]?.date)
        }
        else {
            setTimetable(null)
        }
    }, [language, infoEvents])

    return (
        <>
        <title>展覽活動時間表 - 放視大賞</title>
        <main className="information-time-table flex flex-col justify-between">
            <div className="page-banner">
                <div className="page-banner-content flex flex-wrap gap-4 justify-between items-end">
                    <div className="">
                        <h1 className="title">Time Table</h1>
                        <h2 className="sub-title">時間表</h2>
                    </div>
                    <LanguageBtn />
                </div>
            </div>
            <Transition transitionKey={timetable}>
                { !timetable
                    ?
                    <div className="flex-center">
                        <LoadingIcon />
                    </div>
                    :
                    <>
                    { timetable.length === 0
                        ?
                        <div id="main" className="flex-center pt-[4rem] pb-[6rem]">
                            <img className="w-full" src={comingSoon.src} />
                            <div className="absolute text-center">
                                <div className="text-[1.875rem] text-main-700 font-bold">
                                    2026 放視大賞
                                </div>
                                <div className="text-[3rem] text-main-600 font-bold">
                                    即將公開
                                </div>
                            </div>
                        </div>
                        :
                        <div id="main" className="time-table-content">
                            <div className="table-nav">
                                { timetable.map((time) => (
                                    <button
                                        key={`nav-${time.date}`}
                                        className={classNames('item text-white', {
                                            'active': active === time.date
                                        })}
                                        onClick={() => setActive(time.date)}
                                    >{dayjs(time.date).format('M/DD')}</button>
                                ))}
                                <button
                                    className={classNames('item text-white', {
                                        'active': active === 'overview'
                                    })}
                                    onClick={() => setActive('overview')}
                                >{content?.exhibition_time}</button>
                            </div>

                            <Transition transitionKey={active}>
                                <div className={classNames('table-overview flex-center flex-col pb-[5rem]', {
                                    'hide': active !== 'overview'
                                })}>
                                    <div className="divide-y divide-black-700">
                                        <div className="flex-center flex-col gap-6 px-8 py-4">
                                            <img className="w-[26rem]" src={slogan.src} />
                                            <div className="text-[1.875rem] text-white font-bold">
                                                {content?.exhibition_title}
                                            </div>
                                        </div>
                                        <div className="flex-center flex-col py-5">
                                            <div className="text-white font-bold">
                                                {dayjs(timetable[0].date).format('M/DD')} {translations.weekday?.[dayjs(timetable[0].date).format('d')]} ~
                                                {dayjs(timetable.at(-1).date).format('M/DD')} {translations.weekday?.[dayjs(timetable.at(-1).date).format('d')]}
                                            </div>
                                            <div className="text-[1.125rem] text-white font-bold">
                                                09:00 - 17:00
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-content text-white flex">
                                    <div className={classNames('time-line grid grid-flow-row', {
                                        'hide': active === 'overview'
                                    })}>
                                        <div>09:00</div>
                                        <div>10:00</div>
                                        <div>11:00</div>
                                        <div>12:00</div>
                                        <div>13:00</div>
                                        <div>14:00</div>
                                        <div>15:00</div>
                                        <div>16:00</div>
                                        <div>17:00</div>
                                    </div>
                                    <div className="w-full">
                                        <div
                                            className="grid-wrapper grid grid-flow-row"
                                            style={{
                                                gridTemplateColumns:
                                                    `repeat(${timetable.length * categories.length}, minmax(0, 1fr))`
                                            }}
                                        >
                                            { timetable.map((time, index) => (
                                                // console.log('time', time),
                                                <div
                                                    key={`timetable-date-${time.date}`}
                                                    className={classNames('grid grid-cols-subgrid grid-flow-row', {
                                                        'hide': time.date !== active
                                                    })}
                                                    style={{
                                                        gridTemplateColumns: `repeat(${categories.length}, minmax(0, 1fr))`,
                                                        gridColumn: `span ${categories.length} / span ${categories.length}`
                                                    }}
                                                >
                                                    <div
                                                        className="cell cell-date"
                                                        style={{
                                                            gridColumn: `span ${categories.length} / span ${categories.length}`
                                                        }}
                                                    >
                                                        <div className="text-[1.5rem] text-white">Day{index+1}</div>
                                                        {dayjs(time.date).format('M/DD')} {translations.weekday?.[dayjs(time.date).format('d')]}
                                                    </div>
                                                    { time.categories.map((category) => (
                                                        // console.log('category', category),
                                                        <div
                                                            key={`timetable-${time.date}-${category.shortcut}`}
                                                            className="relative grid grid-cols-subgrid col-span-1 grid-cols-1 grid-flow-row"
                                                        >
                                                            <div className="cell cell-location">
                                                                <div className="font-semibold">
                                                                    {category.label}
                                                                </div>
                                                                <div className="text-[0.6rem] font-light">
                                                                    {category.title}
                                                                </div>
                                                            </div>
                                                            { Array(17).fill('cell').map((cell, index) => {
                                                                return <div key={`cell-${index}`} className="cell h-[3.75rem]"></div>
                                                            })}
                                                            { category.events.map((event) => {
                                                                const start = (dayjs(event.start_time) - dayjs(dayjs(event.start_time).format('YYYY-MM-DD 09:00'))) / 60 / 60 / 1000
                                                                const duration = (dayjs(event.end_time) - dayjs(event.start_time)) / 60 / 60 / 1000
                                                                // console.log('event', event)
                                                                return (
                                                                    <button
                                                                        key={`timetable-${time.date}-${category.shortcut}-${event.id}`}
                                                                        className={classNames('card', {
                                                                            'solid': event.only_time_table
                                                                        })}
                                                                        style={{
                                                                            top: `calc(4.5rem + (${start} * 3.75rem * 2) + 0.15rem)`,
                                                                            height: `calc((${duration} * 3.75rem * 2) - 0.15rem)`,
                                                                        }}
                                                                        onClick={() => {setDetail(event)}}
                                                                    >
                                                                        <div
                                                                            className="name"
                                                                            style={{
                                                                                WebkitLineClamp: Math.round(duration * 4),
                                                                            }}
                                                                        >
                                                                            {event.name}
                                                                        </div>
                                                                        <div className="time">{dayjs(event.start_time).format('HH:mm')} - {dayjs(event.end_time).format('HH:mm')}</div>
                                                                    </button>
                                                                )
                                                            })}
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </Transition>
                            { downloadTimetable &&
                                <div className={classNames('table-download flex justify-end m-auto mt-[3rem] mb-[10rem]', {
                                    'hide': active === 'overview'
                                })}>
                                    <a
                                        className="btn btn-main btn-round h-fit"
                                        href={downloadTimetable.link || downloadTimetable.media?.file}
                                        download={downloadTimetable.download_filename}
                                        target="_blank"
                                        title={`另開新視窗前往下載檔案-${downloadTimetable.download_filename}`}
                                    >{downloadTimetable.display_name}</a>
                                </div>
                            }
                        </div>
                    }
                    </>
                }
            </Transition>
            { detail &&
                <ActivityDetail info={detail} setInfo={setDetail} />
            }
            <Marquee />
        </main>
        </>
    )
}
